import { BaseCampaignsEmail } from '@ag-common-lib/public-api';
import { CommonFireStoreDao, QueryParam } from 'ag-common-svc/lib/dao/CommonFireStoreDao.dao';
import { FirebaseApp } from 'firebase/app';

export class EmailCampaignService<T extends BaseCampaignsEmail> {
  protected readonly fsDao: CommonFireStoreDao<T>;

  constructor(fireBaseApp: FirebaseApp) {
    this.fsDao = new CommonFireStoreDao<T>(fireBaseApp, null, null);
  }

  getList(table: string, qp: QueryParam[] = []) {
    return this.fsDao.getList(table, qp);
  }

  protected async sendEmail(table: string, data: T) {
    const campaignEmails = await this.fsDao.create(data, table).catch(e => {
      console.log('e', e);
    });

    return campaignEmails;
  }
}
